var d = new Date();

// var date = d.getDate();
// var month = d.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
// var year = d.getFullYear();

// var todayDate = date + "-" + month + "-" + year;

export const Campus_Table_Model = [
  "Edit/Delete",
  "Campus Name",
  "University Name",
  "Country",
];

export const Campus_Form_Model = {
  Campus_Name: "",
  Country_Id: "",
  University_Id: "",
  Created_By: "0",
  Created_On: d,
  Modified_By: "0",
  Modified_On: d,
};

export const Campus_Form_Checker = (data) => {
  if (data.Campus_Name === "" || data.Campus_Name === null) {
    return ["Campus Name is Mandatory!"];
  } else if (data.Country_Id === "" || data.Country_Id === null) {
    return ["Country Name is mandatory!"];
  } else if (data.University_Id === "" || data.University_Id === null) {
    return ["University Name is Mandatory!"];
  } else {
    return ["success"];
  }
};
